import React, { FC, useState } from 'react';

import { PVBlack } from '@pv/common/colors';

import type { FilterBarProps } from './index';
import { MobileFilterBarDialog } from './MobileFilterBarDialog';
import { MapPin } from 'react-feather';
import { MobileFilterBarButton } from '../MobileFilterBarButton';
import { getCapacityText } from '../utils';
export const MobileFilterBar: FC<FilterBarProps> = ({
  locationQuery,
  onChangeLocationQuery,
  capacityFilterValues,
  onSubmitCapacityFilter,
  onCancelCapacityFilter,
}: FilterBarProps) => {
  const [open, setOpen] = useState(false);
  const handleClick = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const capacityFilterText = getCapacityText(capacityFilterValues);

  return (
    <div role="search" style={{ width: '100%' }}>
      <MobileFilterBarButton
        startIcon={<MapPin color={PVBlack} />}
        filterText={[locationQuery, capacityFilterText]}
        onClick={handleClick}
      />
      <MobileFilterBarDialog
        isOpen={open}
        onClose={handleClose}
        locationQuery={locationQuery}
        onChangeLocationQuery={onChangeLocationQuery}
        capacityFilterValues={capacityFilterValues}
        onSubmitCapacityFilter={onSubmitCapacityFilter}
        onCancelCapacityFilter={onCancelCapacityFilter}
      />
    </div>
  );
};
